module.exports = __webpack_public_path__ + "62293a8e323acab4f1d5f70329f50b9b.svg";